<!-- 教育行业解决方案模块 -->

<template>
  <div class="solution_box"
    :class="{ 'edu_solution_en': $i18n.locale === 'en_US', 'edu_solution_en edu_solution_ja': $i18n.locale === 'ja_JP' }">
    <div class="edu_solution_content">
      <div class="sheets_box">
        <div class="sheet_content" :style="{
          'background-image': 'url(' + bgData + ')',
          backgroundSize: '100% 100%',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center center',
          width: '1344px',
          height: '766px',
        }">
          <!-- 标题行 -->
          <div class="text_title text-center left_top01_title edu_lh-1">
            {{ $t("solution.education.solutions.image.left_top.tab01_title") }}
          </div>
          <div class="text_title text-center left_top02_title edu_lh-1">
            {{ $t("solution.education.solutions.image.left_top.tab03_title") }}
          </div>
          <div class="text_title text-center left_bottom02_title edu_lh-1">
            {{
              $t("solution.education.solutions.image.left_bottom.tab02_title")
            }}
          </div>
          <div class="text_title text-end right_top02_title edu_lh-1">
            {{ $t("solution.education.solutions.image.right_top.tab02_title") }}
          </div>
          <div class="text_title text-center right_top01_title edu_lh-1">
            {{ $t("solution.education.solutions.image.right_top.tab01_title") }}
          </div>
          <div class="text_title text-center left_center_title edu_lh-1">
            {{ $t("solution.education.solutions.image.left_top.tab02_title") }}
          </div>
          <div class="text_title text-center left_bottom01_title edu_lh-1">
            {{
              $t("solution.education.solutions.image.left_bottom.tab01_title")
            }}
          </div>
          <div class="text_title text-center right_center_title edu_lh-1">
            {{ $t("solution.education.solutions.image.right_top.tab03_title") }}
          </div>
          <div class="text_title text-center right_bottom02_title edu_lh-1">
            {{
              $t("solution.education.solutions.image.right_bottom.tab02_title")
            }}
          </div>
          <div class="text_title text-center right_bottom01_title edu_lh-1">
            {{
              $t("solution.education.solutions.image.right_bottom.tab01_title")
            }}
          </div>
          <div class="text_title text-end bottom_left_title edu_lh-1">
            {{ $t("solution.education.solutions.image.bottom.tab01_title") }}
          </div>
          <div class="text_title text-end bottom_center_title edu_lh-1">
            {{ $t("solution.education.solutions.image.bottom.tab02_title") }}
          </div>
          <div class="text_title text-center bottom_right_title edu_lh-1">
            {{ $t("solution.education.solutions.image.bottom.tab03_title") }}
          </div>

          <!-- 第一列 -->
          <div class="text_normal text-center left_top01">
            {{
              $t(
                "solution.education.solutions.image.left_top.tab01_description"
              )
            }}
          </div>
          <div class="text_normal text-center left_center display_dir_col">
            <div class="display_center div_h">
              {{
                $t(
                  "solution.education.solutions.image.left_top.tab02_description01"
                )
              }}
            </div>
            <div class="display_center div_h">
              {{
                $t(
                  "solution.education.solutions.image.left_top.tab02_description02"
                )
              }}
            </div>
          </div>
          <div class="text_normal text-center left_bottom01 display_dir_col">
            <div class="display_center div_h">
              {{
                $t(
                  "solution.education.solutions.image.left_bottom.tab01_description01"
                )
              }}
            </div>
            <div class="display_center div_h">
              {{
                $t(
                  "solution.education.solutions.image.left_bottom.tab01_description02"
                )
              }}
            </div>
          </div>
          <!-- 第二、三列 -->
          <div class="text_normal text-center left_top02 display_dir_row">
            <div class="div_wh display_dir_col">
              <div class="display_center div_w04">
                {{
                  $t(
                    "solution.education.solutions.image.left_top.tab03_description01"
                  )
                }}
              </div>
              <div class="display_center div_w04">
                {{
                  $t(
                    "solution.education.solutions.image.left_top.tab03_description03"
                  )
                }}
              </div>
              <div class="display_center div_w04">
                {{
                  $t(
                    "solution.education.solutions.image.left_top.tab03_description05"
                  )
                }}
              </div>
              <div class="display_center div_w04">
                {{
                  $t(
                    "solution.education.solutions.image.left_top.tab03_description07"
                  )
                }}
              </div>
            </div>
            <div class="div_wh display_dir_col">
              <div class="display_center div_w04">
                {{
                  $t(
                    "solution.education.solutions.image.left_top.tab03_description02"
                  )
                }}
              </div>
              <div class="display_center div_w04">
                {{
                  $t(
                    "solution.education.solutions.image.left_top.tab03_description04"
                  )
                }}
              </div>
              <div class="display_center div_w04">
                {{
                  $t(
                    "solution.education.solutions.image.left_top.tab03_description06"
                  )
                }}
              </div>
              <div class="display_center div_w04">
                {{
                  $t(
                    "solution.education.solutions.image.left_top.tab03_description08"
                  )
                }}
              </div>
            </div>
          </div>
          <div class="text_normal text-center left_bottom02 display_dir_row">
            <div class="div_wh display_dir_col">
              <div class="display_center div_w04">
                {{
                  $t(
                    "solution.education.solutions.image.left_bottom.tab02_description01"
                  )
                }}
              </div>
              <div class="display_center div_w04">
                {{
                  $t(
                    "solution.education.solutions.image.left_bottom.tab02_description03"
                  )
                }}
              </div>
              <div class="display_center div_w04">
                {{
                  $t(
                    "solution.education.solutions.image.left_bottom.tab02_description05"
                  )
                }}
              </div>
              <div class="display_center div_w04">
                {{
                  $t(
                    "solution.education.solutions.image.left_bottom.tab02_description07"
                  )
                }}
              </div>
            </div>
            <div class="div_wh display_dir_col">
              <div class="display_center div_w04">
                {{
                  $t(
                    "solution.education.solutions.image.left_bottom.tab02_description02"
                  )
                }}
              </div>
              <div class="display_center div_w04">
                {{
                  $t(
                    "solution.education.solutions.image.left_bottom.tab02_description04"
                  )
                }}
              </div>
              <div class="display_center div_w04">
                {{
                  $t(
                    "solution.education.solutions.image.left_bottom.tab02_description06"
                  )
                }}
              </div>
              <div class="display_center div_w04">
                {{
                  $t(
                    "solution.education.solutions.image.left_bottom.tab02_description08"
                  )
                }}
              </div>
            </div>
          </div>
          <!-- 第四、五列 -->
          <div class="text_normal text-center right_top02 display_dir_col">
            <div class="display_dir_row">
              <div class="display_center div_h div_w01">
                {{
                  $t(
                    "solution.education.solutions.image.right_top.tab02_description01"
                  )
                }}
              </div>
              <div class="display_center div_h div_w01">
                {{
                  $t(
                    "solution.education.solutions.image.right_top.tab02_description02"
                  )
                }}
              </div>
            </div>
            <div class="display_dir_row">
              <div class="display_center div_h div_w02">
                {{
                  $t(
                    "solution.education.solutions.image.right_top.tab02_description03"
                  )
                }}
              </div>
              <div class="display_center div_h div_w02">
                {{
                  $t(
                    "solution.education.solutions.image.right_top.tab02_description04"
                  )
                }}
              </div>
              <div class="display_center div_h div_w02">
                {{
                  $t(
                    "solution.education.solutions.image.right_top.tab02_description05"
                  )
                }}
              </div>
            </div>
          </div>
          <div class="text_normal text-center right_center display_dir_col">
            <div class="display_dir_row">
              <div class="display_center div_h div_w01">
                {{
                  $t(
                    "solution.education.solutions.image.right_top.tab03_description01"
                  )
                }}
              </div>
              <div class="display_center div_h div_w01">
                {{
                  $t(
                    "solution.education.solutions.image.right_top.tab03_description02"
                  )
                }}
              </div>
            </div>
            <div class="display_dir_row">
              <div class="display_center div_h div_w02">
                {{
                  $t(
                    "solution.education.solutions.image.right_top.tab03_description03"
                  )
                }}
              </div>
              <div class="display_center div_h div_w02">
                {{
                  $t(
                    "solution.education.solutions.image.right_top.tab03_description04"
                  )
                }}
              </div>
              <div class="display_center div_h div_w02">
                {{
                  $t(
                    "solution.education.solutions.image.right_top.tab03_description05"
                  )
                }}
              </div>
            </div>
          </div>
          <div class="text_normal text-center right_bottom02 display_dir_col">
            <div class="display_dir_row">
              <div class="display_center div_h div_w01">
                {{
                  $t(
                    "solution.education.solutions.image.right_bottom.tab02_description01"
                  )
                }}
              </div>
              <div class="display_center div_h div_w01">
                {{
                  $t(
                    "solution.education.solutions.image.right_bottom.tab02_description03"
                  )
                }}
              </div>
            </div>
            <div class="display_dir_row">
              <div class="display_center div_h div_w01">
                {{
                  $t(
                    "solution.education.solutions.image.right_bottom.tab02_description02"
                  )
                }}
              </div>
              <div class="display_center div_h div_w01">
                {{
                  $t(
                    "solution.education.solutions.image.right_bottom.tab02_description04"
                  )
                }}
              </div>
            </div>
            <div class="display_dir_row">
              <div class="display_center div_h div_w03">
                {{
                  $t(
                    "solution.education.solutions.image.right_bottom.tab02_description05"
                  )
                }}
              </div>
            </div>
          </div>
          <!-- 第六列 -->
          <div class="text_normal text-center right_top01 display_dir_col">
            <div class="display_center div_h">
              {{
                $t(
                  "solution.education.solutions.image.right_top.tab01_description01"
                )
              }}
            </div>
            <div class="display_center div_h">
              {{
                $t(
                  "solution.education.solutions.image.right_top.tab01_description02"
                )
              }}
            </div>
            <div class="display_center div_h">
              {{
                $t(
                  "solution.education.solutions.image.right_top.tab01_description03"
                )
              }}
            </div>
            <div class="display_center div_h">
              {{
                $t(
                  "solution.education.solutions.image.right_top.tab01_description04"
                )
              }}
            </div>
          </div>
          <div class="text_normal text-center right_bottom01 display_dir_col">
            <div class="display_center div_h">
              {{
                $t(
                  "solution.education.solutions.image.right_bottom.tab01_description01"
                )
              }}
            </div>
            <div class="display_center div_h">
              {{
                $t(
                  "solution.education.solutions.image.right_bottom.tab01_description02"
                )
              }}
            </div>
            <div class="display_center div_h">
              {{
                $t(
                  "solution.education.solutions.image.right_bottom.tab01_description03"
                )
              }}
            </div>
          </div>
          <!-- 最后一行 -->
          <div class="text_normal text-center bottom_left_01">
            {{
              $t(
                "solution.education.solutions.image.bottom.tab01_description01"
              )
            }}
          </div>
          <div class="text_normal text-center bottom_left_02">
            {{
              $t(
                "solution.education.solutions.image.bottom.tab01_description02"
              )
            }}
          </div>
          <div class="text_normal text-center bottom_left_03">
            {{
              $t(
                "solution.education.solutions.image.bottom.tab01_description03"
              )
            }}
          </div>
          <div class="text_normal text-center bottom_center_01">
            {{
              $t(
                "solution.education.solutions.image.bottom.tab02_description01"
              )
            }}
          </div>
          <div class="text_normal text-center bottom_center_02">
            {{
              $t(
                "solution.education.solutions.image.bottom.tab02_description02"
              )
            }}
          </div>
          <div class="text_normal text-center bottom_right">
            {{
              $t("solution.education.solutions.image.bottom.tab03_description")
            }}
          </div>
        </div>
      </div>
    </div>
    <div class="desc_box">
      {{ $t("solution.education.solutions.image.description") }}
    </div>
  </div>
</template>

<script>

export default {
  name: 'EducationSolution',
  data () {
    return {
      bgData: require('../../../../assets/images/IndustrySolution/educationSolution/edu_solution_sheet_bg.png'),
    }

  }
}
</script>